import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ebeihilfe-cross-svg',
  templateUrl: './cross-svg.component.svg',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
})
export class CrossSvgComponent {}
